/**
 * 邮箱
 * @param {*} s
 */
export function isEmail(s) {
  return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(s);
}
/**
 * 手机号码
 * @param {*} s
 */
export function isMobile(s) {
  return /^1[0-9]{10}$/.test(s);
}
/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s);
}
/**
 * 验证合法URL
 * @param {*} textval
 */
export function validateURL(textval) {
  const urlregex =
    /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}
/**
 * 只能为数字验证
 * @param {*} s
 * @returns
 */
export function isNumber(s) {
  ///^[1-9]\d$/
  return /^\d+$/.test(s);
}

/**
 * 只能为数字和字母验证
 * @param {*} s
 * @returns
 */
export function isCharacter(s) {
  ///^[1-9]\d$/
  return /^\w+$/.test(s);
}
/**
 * 验证中文
 */
export function isChinese(s) {
  return /[\u4e00-\u9fa5]+/g.test(s);
}
/* 是否身份证号码*/
export function validateIdNo(rule, value, callback) {
  const reg = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}/;
  if (value == "" || value == undefined || value == null) {
    callback();
  } else {
    if (!reg.test(value) && value != "") {
      callback(new Error("请输入正确的身份证号码"));
    } else {
      callback();
    }
  }
}
/* 验证输入姓名*/
//用户名正则，4到16位（字母，数字，下划线，减号）
export function isUserName(s) {
  // const UserNameregex = /^[a-zA-Z0-9_\-u4e00-\u9fa5]{2,16}$/;
  const UserNameregex = /^[\u4e00-\u9fa5]{2,16}$/;
  return UserNameregex.test(s);
}

// 正整数
export function isUnsignedInt(rule, value, callback) {
  const reg = /^[1-9]\d*$/;
  if (!reg.test(value)) {
    return callback(new Error("请输入大于0的整数"));
  } else {
    callback();
  }
}
